import { initialPropsExperimentConfig } from '@retail/funnel-components';

/**
 * @type {import('@retail/funnel-components/types/buildConfig/types').ICarleadCreationAppConfig}
 */
export const funnelOptions = {
  trackLandingPageType: 'lead',
  emailSuggestionEnabled: true,
  redirectOnSuccessUrl: '/de/booking/{hash}/',
  featuresFlags: {
    postalCode: true,
    honeyPotEmail: false,
    redirectToSelfEvaluation: true,
    selfEvaHideOnlinePriceBucket: true,
    dropOffEmailDelayInMinutes: 20,
  },
  abExperiment: initialPropsExperimentConfig.carleadCreation,
};
